// extracted by mini-css-extract-plugin
module.exports = {"menus":"index_menus_12Phh","icon":"index_icon_263Le","title":"index_title_3IHjc","ManageModel":"index_ManageModel_2eGmL"};